import { IEvent } from "@quest/adapter-interface";
import { BaseViewBehavior } from "@quest/murka-games-behavior-panther/dist";
import { ingenuity, SpineBase } from "@quest/base-core";

export class FgClusterWinFrameView extends BaseViewBehavior {
  /** Resize */
  protected resize(evt: IEvent): void {
    if (!ingenuity.deviceEnv.isDesktop) {
      if (this.CurrentOrientation !== ingenuity.deviceEnv.getOrientation()) {
        this.CurrentOrientation = ingenuity.deviceEnv.getOrientation();
        this.updateOrientation();
      }
    }
  }

  // To create spine clone animation
  public createSpineClone(ISpineData: any): SpineBase {
    return this.createSpine(ISpineData);
  }
}
